import React from 'react';
import PropTypes from 'prop-types';
import Styles from './styles';
import SelectableListItem from '../SelectableListItem';
import ActionPanel from '../ActionPanel';
import { WIDGETS } from '../../constants';

const AddWidgetPanel = (props) => {
  const { ...actionPanelProps } = props;
  return (
    <ActionPanel
      title="Choose widget to add"
      wrapperStyle={Styles.wrapper}
      wrapperOpenStyle={Styles.wrapperOpen}
      style={Styles.widgets}
      {...actionPanelProps}
    >
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.PORTAL);
        }}
        style={Styles.widget}
      >
        Portal
      </SelectableListItem>
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.SOUND);
        }}
        style={Styles.widget}
      >
        Sound
      </SelectableListItem>
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.INFO_WINDOW);
        }}
        style={Styles.widget}
      >
        Info window
      </SelectableListItem>
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.GALLERY);
        }}
        style={Styles.widget}
      >
        Photo gallery
      </SelectableListItem>
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.MAP);
        }}
        style={Styles.widget}
      >
        Map
      </SelectableListItem>
      <SelectableListItem
        onClick={() => {
          props.onItemClick(WIDGETS.TEXT);
        }}
        style={Styles.widget}
      >
        Text
      </SelectableListItem>
    </ActionPanel>
  );
};

AddWidgetPanel.propTypes = {
  isOpen: PropTypes.bool,
  onItemClick: PropTypes.func,
};

AddWidgetPanel.defaultProps = {
  isOpen: false,
  onItemClick: () => {},
};

export default AddWidgetPanel;



// WEBPACK FOOTER //
// ./src/components/AddWidgetPanel/index.js